import { INCREASE_ICON } from '@aws-amplify/ui-react/dist/types/primitives/StepperField/StepperField';
import { createContext } from 'react';
import { IEventData, INutritionData, IUserData } from '../interfaces';
import { IPostUserData } from '../api';

interface IGlobalContext {
    // Data from the back end (products etc. and event nutrition)
    nutritionData: INutritionData | {},
    setNutritionData: (arg: INutritionData) => void,

    // User data
    userData: {
        user?: IUserData ,
        haveFetched: boolean
    } ,
    setUserData: (arg: {
        user?: IUserData,
        haveFetched: boolean}) => void,

    // Basket
    clearBasket: () => void,
    basket: {
        gels: number,
        drinks: number,
        bars: number,
        saltCapsule: number,
        saltChew: number,
    },
    addGel: (x: number) => void,
    addDrink: (x: number) => void,
    addBar: (x: number) => void,
    addSaltCapsule: (x: number) => void,
    addSaltChew: (x: number) => void,

    // The current event
    eventData: {
        event?: Partial<IEventData>
    }
    setEventData: (data: Partial<IEventData>) => void,
    clearEventData: () => void,
}

export const GlobalContext = createContext<IGlobalContext>({
    nutritionData: {},
    clearBasket: () => {return},
    setNutritionData: (arg: INutritionData) => { return },
    userData: {
        haveFetched: false
    },
    setUserData: (arg: {
        user?: IUserData,
        haveFetched: boolean}) => { return },
    basket: {
        gels: 0,
        drinks: 0,
        bars: 0,
        saltCapsule: 0,
        saltChew: 0,
    },
    addGel: (x: number) => {},
    addDrink: (x: number) => {},
    addBar: (x: number) => {},
    addSaltCapsule: (x: number) => {},
    addSaltChew: (x: number) => {},

    eventData : {},
    setEventData: (x : Partial<IEventData>) => {},
    clearEventData: () => {},
});